import { useEffect, useState } from "react";
import useDomainIntegration from "./useDomainIntegration";
import { message } from "antd";
import {
  createAndUpdateDomainIdentifier,
  updateDomainIdentifiers,
} from "./service";

function useWhitelistDomain(workspaceId, assistantId) {
  const {
    data,
    isLoading,
    isCreated,
    fetchDomainIntegration,
    setDomainIntegration,
  } = useDomainIntegration(workspaceId, assistantId);
  const [openDelete, setOpenDelete] = useState({
    item: null,
    index: null,
    isOpen: false,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchDomainIntegration();
  }, []);

  const handleUpdateDomainIdentifiers = async (payload, onSuccess) => {
    message.loading("Updating domains list");
    setLoading(true);

    try {
      const response = await updateDomainIdentifiers({
        workspaceId,
        assistantId,
        payload,
      });
      if (response.status === 200) {
        fetchDomainIntegration();
        setLoading(false);
        message.destroy();
        message.success("Domains updated");
        onSuccess();
      }
    } catch (e) {
      setLoading(false);
      message.destroy();
      message.error(e.response.data?.msg || e.response.data?.message || e.response.data?.error || "Failed to update domains list");
    }
  };

  const handleCreateDomainIdentifier = async (payload, onSuccess) => {
    message.loading("Updating domains list");
    setLoading(true);
    const updatedPayload = {
      domainIdentifiers: payload.domains,
    };

    try {
      const response = await createAndUpdateDomainIdentifier({
        workspaceId,
        assistantId,
        payload: updatedPayload,
      });
      if (response.status === 200) {
        setDomainIntegration((prevState) => {
          return {
            data: {
              domainIdentifiers: response.data.domainIdentifiers,
            },
            isLoading: false,
            isCreated: true,
          };
        });
        setLoading(false);
        message.destroy();
        message.success("Domains updated");
        onSuccess();
      }
    } catch (e) {
      setLoading(false);
      message.destroy();
      message.error(e.response.data?.msg || e.response.data?.message || e.response.data?.error || "Failed to update domains list");
    }
  };

  return {
    data,
    isLoading,
    isCreated,
    fetchDomainIntegration,
    setDomainIntegration,
    openDelete,
    setOpenDelete,
    loading,
    handleUpdateDomainIdentifiers,
    handleCreateDomainIdentifier,
  };
}

export default useWhitelistDomain;
